<div class="flex flex-col h-full bg-base-100 border-r border-base-content/10">

    <!-- Header -->
    <!-- Výška a linka shodné s topbarem (h-16 + border-b) — horní pás čte jako jedna lišta. -->
    <div class="flex items-center justify-between h-16 shrink-0 px-4 border-b border-base-content/10">
        <a [routerLink]="'/page/dashboard'" class="flex items-center gap-2 no-underline">
            <img src="assets/images/gg-logo-no-text.svg" height="28" width="28" alt="GuideGlare"/>
            <span class="text-sm font-bold tracking-wide">GUIDE<span class="text-primary">GLARE</span></span>
        </a>
        <!-- Sbalení: desktop; protějšek (rozbalení) je první prvek topbaru -->
        <button type="button" class="btn btn-ghost btn-sm btn-square hidden lg:flex" (click)="toggleSidebar()"
                [attr.aria-label]="'common.collapse' | translate">
            <app-icon icon="app:sidebarToggle" size="md" class="opacity-60" />
        </button>
        <label for="left-sidebar-drawer" class="btn btn-ghost btn-sm btn-square lg:hidden" [attr.aria-label]="'common.close' | translate">
            <app-icon icon="app:close" size="md" />
        </label>
    </div>

    <!-- Nav -->
    <div class="flex-1 overflow-y-auto px-2 pb-4 custom-scrollbar">
        <ul class="menu p-0 sidebar-nav">
            @for (menu of getAvailableMenuItems(); track menu.key) {

                @if (menu.isTitle) {
                    <li class="menu-title mt-4">{{ menu.label | translate }}</li>
                } @else if (!menu.isSeparator) {

                    @if (!hasSubmenu(menu)) {
                        <li>
                            <a [routerLink]="menu.link" [queryParams]="menu.queryParams || null"
                               [ngClass]="{'menu-active': activeMenuItems.includes(menu.key)}"
                               [attr.data-menu-key]="menu.key"
                               (click)="closeMobileMenuOnNavigation()">
                                @if (menu.icon) {
                                    <app-icon [icon]="menu.icon" size="md" class="shrink-0" />
                                }
                                {{ menu.label | translate }}
                                @if (hasFreeSubscription && menu.freePlanAvailability) {
                                    <span class="ml-auto flex"
                                          [appTooltip]="'premium.feature.' + menu.freePlanAvailability"
                                          [placement]="tooltipPlacement">
                                        <app-icon [icon]="menu.freePlanAvailability === 'unavailable' ? 'app:premium' : 'app:premium'"
                                                  size="sm" class="text-warning shrink-0" />
                                    </span>
                                }
                                @if (menu.key === 'apps-whats-new' && whatsNewService.unreadCount() > 0) {
                                    <span class="badge badge-xs badge-primary font-mono ml-auto">{{ whatsNewService.unreadCount() }}</span>
                                }
                            </a>
                        </li>
                    } @else {
                        <li>
                            <a href="javascript: void(0)"
                               [ngClass]="{'menu-active': activeMenuItems.includes(menu.key)}"
                               (click)="toggleMenuItem(menu)">
                                @if (menu.icon) {
                                    <app-icon [icon]="menu.icon" size="md" class="shrink-0" />
                                }
                                {{ menu.label | translate }}
                                <span class="sidebar-chevron ml-auto" [class.is-collapsed]="menu.collapsed">▾</span>
                            </a>

                            @if (!menu.collapsed) {
                                <ul class="menu p-0 mt-1 border-l-2 border-base-200 pl-2">
                                    @for (child of menu.children; track child.key) {
                                        @if (isAvailable(child)) {
                                            <li>
                                                <a [routerLink]="child.link" [queryParams]="child.queryParams || null"
                                                   [ngClass]="{'menu-active': activeMenuItems.includes(child.key)}"
                                                   (click)="closeMobileMenuOnNavigation()">
                                                    {{ child.label | translate }}
                                                </a>
                                            </li>
                                        }
                                    }
                                </ul>
                            }
                        </li>
                    }
                }
            }
        </ul>
    </div>

    <!-- Footer -->
    <div class="mt-auto border-t border-base-200">

        <!-- Dev-only přepínač zaměření (environment.devIntentSwitcher = local + dev, v prod vypnutý) -->
        <div class="px-4 pt-4">
            <app-dev-intent-switcher/>
        </div>

        <!-- „Koupit předplatné" (FREE) — jen pod `md`, kde je topbarový blok schovaný
             (`hidden md:inline-flex`); stav plánu nese kroužek kolem avataru v profilu níž. -->
        <div class="px-4 pt-4 md:hidden">
            <app-usage-chip variant="sidebar"/>
        </div>

        <div class="px-2 py-3">
            <app-sidebar-profile-dropdown />
        </div>
    </div>
</div>
